<template>
  <TheGreyWrapper>
    <TheHeader
      :back-route="backRoute"
      force-sm-style
    />
    <BaseSection>
      <BaseTitleGroup
        :subtitle="opportunity && opportunity.data.attributes.name"
        :title="$t('Investment entity creation')"
        class="mb-6"
      />
      <BaseParagraph>
        {{ $t('Please enter your entity information') }} :
      </BaseParagraph>
      <BaseRadioButtons
        v-model="chosenItem"
        :items="items"
        class="mb-2"
      >
        <BaseRadioButton
          slot-scope="slotProps"
          :active="slotProps.active"
        >
          {{ slotProps.item.text }}
        </BaseRadioButton>
      </BaseRadioButtons>
      <BaseButton
        :title="$t('Confirm')"
        class="mb-8"
        @click.native="openInvestmentEntityForm"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import BaseRadioButtons from '../components/BaseRadioButtons.vue';
import BaseRadioButton from '../components/BaseRadioButton.vue';
import BaseButton from '../components/BaseButton.vue';
import TheHeader from '../components/TheHeader.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import loadOpportunity from '../mixins/loadOpportunity';

export default {
  name: 'InvestmentEntityKindChoice',
  metaInfo: {
    title: "Entité d'investissement",
  },
  components: {
    BaseSection,
    BaseTitleGroup,
    TheHeader,
    BaseParagraph,
    BaseRadioButton,
    BaseRadioButtons,
    BaseButton,
    TheGreyWrapper,
  },
  mixins: [loadOpportunity],
  data() {
    const firstItem = {
      companyType: 'person',
      text: this.$t('Person kind hint'),
    };
    let backRoute = '.';
    if (this.$route.query.fromOpportunity) {
      backRoute = '../accept';
    }
    return {
      items: [
        firstItem,
        {
          companyType: 'company',
          text: this.$t('Company kind hint'),
        },
      ],
      chosenItem: firstItem,
      backRoute,
    };
  },
  methods: {
    openInvestmentEntityForm() {
      this.$router.push(`new/${this.chosenItem.companyType}`);
    },
  },
};
</script>
